import React, { useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import {
  MdPerson,
  MdStore,
  MdSettings,
  MdPayment,
  MdNotifications,
  MdSecurity,
  MdWarning
} from 'react-icons/md';
import '../../../assets/css/equipmentrentaladmin/settings/Settings.css';
import RentalAdminLayout from '../../../layout/equipmentrentaladmin/RentalAdminLayout';

const Settings = () => {
  const [settings, setSettings] = useState({
    adminName: 'Rental Admin',
    adminEmail: 'admin@agrirental.com',
    phone: '0301-1234567',

    shopName: 'Agri Rental Hub',
    shopAddress: 'Lahore, Pakistan',
    currency: 'PKR',

    minRentalDays: 1,
    maxRentalDays: 30,
    securityDeposit: true,

    commissionPercent: 10,
    paymentMethod: 'cash',

    emailNotifications: true,
    smsNotifications: false,

    darkMode: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSave = () => {
    console.log('Dashboard Settings:', settings);
    alert('Dashboard settings saved successfully');
  };

  return (
    <RentalAdminLayout>
    <div className="dashboard-content">
      <div className="page-header">
        <h2 className="page-title">Dashboard Settings</h2>
      </div>

      {/* ================= ADMIN ================= */}
      <div className="content-card mb-4">
        <h4 className="section-title"><MdPerson /> Admin Settings</h4>
        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Admin Name</Form.Label>
              <Form.Control
                name="adminName"
                value={settings.adminName}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="adminEmail"
                value={settings.adminEmail}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                name="phone"
                value={settings.phone}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>
      </div>

      {/* ================= BUSINESS ================= */}
      <div className="content-card mb-4">
        <h4 className="section-title"><MdStore /> Business Settings</h4>
        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Shop Name</Form.Label>
              <Form.Control
                name="shopName"
                value={settings.shopName}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                name="shopAddress"
                value={settings.shopAddress}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Currency</Form.Label>
              <Form.Select
                name="currency"
                value={settings.currency}
                onChange={handleChange}
              >
                <option value="PKR">PKR</option>
                <option value="USD">USD</option>
                <option value="AED">AED</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </div>

      {/* ================= RENTAL RULES ================= */}
      <div className="content-card mb-4">
        <h4 className="section-title"><MdSettings /> Rental Rules</h4>
        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Min Rental Days</Form.Label>
              <Form.Control
                type="number"
                name="minRentalDays"
                value={settings.minRentalDays}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Max Rental Days</Form.Label>
              <Form.Control
                type="number"
                name="maxRentalDays"
                value={settings.maxRentalDays}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={4} className="d-flex align-items-center">
            <Form.Check
              type="switch"
              label="Security Deposit Required"
              name="securityDeposit"
              checked={settings.securityDeposit}
              onChange={handleChange}
            />
          </Col>
        </Row>
      </div>

      {/* ================= PAYMENTS ================= */}
      <div className="content-card mb-4">
        <h4 className="section-title"><MdPayment /> Payments</h4>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Commission (%)</Form.Label>
              <Form.Control
                type="number"
                name="commissionPercent"
                value={settings.commissionPercent}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Default Payment Method</Form.Label>
              <Form.Select
                name="paymentMethod"
                value={settings.paymentMethod}
                onChange={handleChange}
              >
                <option value="cash">Cash</option>
                <option value="bank">Bank Transfer</option>
                <option value="jazzcash">JazzCash</option>
                <option value="easypaisa">EasyPaisa</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </div>

      {/* ================= NOTIFICATIONS ================= */}
      <div className="content-card mb-4">
        <h4 className="section-title"><MdNotifications /> Notifications</h4>
        <Form.Check
          type="switch"
          label="Email Notifications"
          name="emailNotifications"
          checked={settings.emailNotifications}
          onChange={handleChange}
        />
        <Form.Check
          type="switch"
          label="SMS Notifications"
          name="smsNotifications"
          checked={settings.smsNotifications}
          onChange={handleChange}
        />
      </div>

      {/* ================= SYSTEM ================= */}
      <div className="content-card mb-4">
        <h4 className="section-title"><MdSecurity /> System Preferences</h4>
        <Form.Check
          type="switch"
          label="Enable Dark Mode"
          name="darkMode"
          checked={settings.darkMode}
          onChange={handleChange}
        />
      </div>

      {/* ================= DANGER ================= */}
      <div className="content-card danger-card">
        <h4 className="section-title danger"><MdWarning /> Danger Zone</h4>
        <Button variant="danger">Reset Dashboard Settings</Button>
      </div>

      <div className="settings-actions">
        <Button className="primary-btn" onClick={handleSave}>
          Save All Settings
        </Button>
      </div>
    </div>
    </RentalAdminLayout>
  );
};

export default Settings;

